<div class="glxy-table-header">
  <div class="glxy-table-filter-and-search">
    <div class="filter-search-group">
      @if (showFilters) {
        @if (showFiltersButton) {
          <button
            mat-stroked-button
            class="table-btn glxy-filters-toggle"
            data-action="clicked-glxy-table-filters-toggle"
            [ngClass]="{ on: showFiltersOpen }"
            (click)="toggleFilterBar()"
          >
            <span class="glxy-filters-indicator-wrap table-btn-icon">
              <mat-icon>filter_list</mat-icon>
              @if (showFiltersApplied) {
                <span
                  class="glxy-filters-indicator"
                  [attr.aria-label]="'GALAXY.TABLE.FILTERS.APPLIED_INDICATOR' | translate"
                ></span>
              }
            </span>
            <span class="hide-on-small">{{ 'GALAXY.TABLE.FILTERS.TOGGLE_BUTTON' | translate }}</span>
          </button>
        } @else {
          <ng-content select="[filter-button]" />
        }
      }
      @if (showSearch) {
        <glxy-form-field class="glxy-table-search" suffixIcon="search" [showLabel]="false" [bottomSpacing]="false">
          <glxy-label>Search</glxy-label>
          <input type="search" placeholder="Search" matInput [formControl]="searchControl" />
        </glxy-form-field>
      }
    </div>
    <div class="after-search">
      <ng-content select="[after-search]" />
    </div>
  </div>

  <div class="glxy-table-actions">
    @if (showDisplayToggle) {
      <mat-button-toggle-group
        [value]="this.display()"
        (change)="onChangeDisplayOption($event.value)"
        class="toggle-btn"
      >
        <mat-button-toggle class="toggle-btn-icon" value="grid" data-action="clicked-glxy-table-display-options">
          <mat-icon>grid_view</mat-icon>
        </mat-button-toggle>
        <mat-button-toggle class="toggle-btn-icon" value="list" data-action="clicked-glxy-table-display-options">
          <mat-icon>format_list_bulleted</mat-icon>
        </mat-button-toggle>
      </mat-button-toggle-group>
    }
    @if (showSort) {
      <button mat-stroked-button class="table-btn" data-action="clicked-glxy-table-sort">
        <span class="table-btn-icon"><mat-icon>sort</mat-icon></span>
        <span class="hide-on-small">Sort</span>
      </button>
    }
    @if (showColumnArrange) {
      <glxy-column-sort [type]="columnArrangeType" />
    }
    @if (showExport) {
      <button mat-stroked-button class="table-btn" data-action="clicked-glxy-table-export" (click)="this.export.emit()">
        <span class="table-btn-icon"><mat-icon>cloud_download</mat-icon></span>
        <span class="hide-on-small">Export</span>
      </button>
    }
  </div>
</div>
@if (showFilters) {
  <div class="glxy-filter-bar" [@openClose]="showFiltersOpen ? 'open' : 'closed'">
    <div class="glxy-filter-bar-inner-space">
      <ng-content select="[filters-area]" />
    </div>
  </div>
}
@if (numSelected$ | async; as numSelected) {
  @if (showActions) {
    <div class="glxy-table-selection-bar">
      @if (!showSelectedAllCount) {
        <div class="selection-count">{{ 'GALAXY.TABLE.SELECTION_BAR.SELECTED_COUNT' | translate: { numSelected: numSelected, limit: rowsSelectionLimit } }} &rarr;</div>
      }
      <div class="optional-select-all">
        <ng-content select="[optional-select-all]" />
      </div>
      @if (!hideActionButton) {
        <button
          mat-stroked-button
          class="table-btn"
          [matMenuTriggerFor]="actionsMenu"
          data-action="clicked-glxy-table-actions"
        >
          <span class="table-btn-icon"><mat-icon>flash_on</mat-icon></span>
          <span>{{ 'GALAXY.TABLE.SELECTION_BAR.ACTIONS' | translate }}</span>
        </button>
        <mat-menu #actionsMenu="matMenu">
          <ng-content select="[mat-menu-item]"></ng-content>
        </mat-menu>
      }
    </div>
  }
}
